var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 11,
    viewBox: "0 0 5 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86563 1.34313C4.90855 1.29542 4.94211 1.2393 4.96438 1.17797C4.98665 1.11665 4.99721 1.05131 4.99544 0.985697C4.99367 0.920085 4.97962 0.85548 4.95408 0.795573C4.92854 0.735665 4.89202 0.681627 4.8466 0.636544C4.80118 0.591462 4.74775 0.556217 4.68937 0.532823C4.63098 0.509429 4.56878 0.498344 4.50631 0.5002C4.44384 0.502056 4.38234 0.516817 4.3253 0.543641C4.26826 0.570464 4.21682 0.608825 4.1739 0.656533L0.130042 5.15389C0.0465311 5.24667 0 5.36951 0 5.49719C0 5.62487 0.0465311 5.74771 0.130042 5.84049L4.1739 10.3384C4.21653 10.3871 4.26797 10.4265 4.32521 10.4542C4.38246 10.4819 4.44437 10.4973 4.50736 10.4997C4.57035 10.502 4.63315 10.4912 4.69212 10.4679C4.75109 10.4445 4.80506 10.4091 4.85088 10.3636C4.89671 10.3182 4.93348 10.2636 4.95906 10.2031C4.98464 10.1426 4.99852 10.0774 4.99989 10.0112C5.00126 9.94499 4.9901 9.87918 4.96705 9.81756C4.944 9.75595 4.90953 9.69976 4.86563 9.65225L1.13006 5.49719L4.86563 1.34313Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationBackArrow);
export default __webpack_public_path__ + "static/media/pagination_back_arrow.c6631b275c12e20e40402ccb54c0b7db.svg";
export { ForwardRef as ReactComponent };